<template>
  <div>
    <GlobalTable
      :title="title+' List'"
      :fields="fields"
      :items="items"
      :editButton="false"
      :redirectDetail="false"
      :isLoading="isLoading"
      @addForm="addForm"
      @editForm="editForm"
      :enableAddButton="false"
    ></GlobalTable>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{title}}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CForm>
          <CRow>
            <CCol sm="3">
              <CInput
                label="Province Name"
                invalid-feedback="province name should be filled"
                required
                v-model="$v.provinceForm.name.$model"
                :is-valid="!$v.provinceForm.name.$invalid"
              />
            </CCol>
            <CCol sm="3">
              <CInput
                label="Province Code"
                invalid-feedback="province code should be filled"
                required
                v-model="$v.provinceForm.province_code.$model"
                :is-valid="!$v.provinceForm.province_code.$invalid"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="12">
              <label for="nik">Description</label>
              <quill-editor style="height: 200px; margin-bottom:70px;"
                :content="content"
                :options="editorOption"
                v-model="$v.provinceForm.description.$model"
                @change="onEditorChange($event)">
              </quill-editor>
              <div v-if="$v.provinceForm.description.$invalid" class="invalid-feedback-custom">
                Description harus di isi.
              </div>
              <!-- <CTextarea
                rows="4"
                label="Description"
                invalid-feedback="Description should be filled"
                required
                v-model="$v.productCategoryForm.description.$model"
                :is-valid="!$v.productCategoryForm.description.$invalid"
              /> -->
            </CCol>
          </CRow>
        </CForm>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.provinceForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import Loading from "../../../templates/Loading";

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'

export default {
  name: "province",
  components: { GlobalTable, Loading, quillEditor },
  data() {
    return {
      title: "province",
      fields: [
        { key: "name", label: "Nama Provinsi", sorter: true },
        { key: "province_code", label: "Kode Provinsi", sorter: true },
        { key: "description", label: "Description", sorter: true },
        // { key: "action", _classes: "text-center action" },
      ],
      items: [],
      provinceForm: tableInterfaces.province,
      isLoading: false,
      addButton: false,
      isEdit: false,

       options: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
      content: '',editorOption: {},	// data quill
    };
  },
  validations: {
    provinceForm: {
      name: { required },
      province_code: { required },
      description: {}
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getprovince();
    },
    getprovince: function () {
      this.isLoading = true;
      this.axios
        .get("console/master/province/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            // console.log(response.data.data)
            this.items = response.data.data;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.provinceForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.province) {
        tableInterfaces.province[i] = null;
      }
      this.provinceForm = tableInterfaces.province;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (this.isEdit === true) {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/master/province/edit", this.provinceForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      } else {
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          this.axios
            .post("console/master/province/add", this.provinceForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      }
    },
  },
  onEditorChange({ quill, html, text }) {
    this.content = html
    this.districtForm.description = html
  },
  mounted() {
    this.init();
  },
};
</script>
